import { __assign } from "tslib";
import { createCompaniesApi } from '.';
import { createFakeGetResponder, createFakeDeleteResponder, createFakePostResponder, createFakePutResponder, isWildcard } from '../test-utils';
import { createHttpTestKit } from '../http/test-kit';
import { createSimpleCustomFieldsApiTestKitHandler } from '..';
export var createCompaniesApiTestkit = function (parent) {
    if (parent === void 0) { parent = 'localhost'; }
    var fakeHttp = createHttpTestKit();
    var api = createCompaniesApi(parent, fakeHttp);
    var base = parent + "/companies";
    var handler = {
        whenGetAllCompanies: function () { return createFakeGetResponder(fakeHttp, "" + base); },
        whenAddCompany: createFakePostResponder(fakeHttp, "" + base),
        whenBulkAddCompanies: createFakePostResponder(fakeHttp, base + "/bulk"),
        whenDeleteCompany: function (dto) { return createFakeDeleteResponder(fakeHttp, base + "/" + dto.id); },
        whenGetCompany: function (dto) { return createFakeGetResponder(fakeHttp, base + "/" + dto.id); },
        whenSearch: createFakePostResponder(fakeHttp, base + "/search/admin"),
        whenUpdateCompany: createFakePutResponder(fakeHttp, "" + base),
        whenCustomFields: createSimpleCustomFieldsApiTestKitHandler(base, fakeHttp),
        whenUpdateCompanyFields: function (dto) {
            return createFakePutResponder(fakeHttp, "/" + (isWildcard(dto) ? '' : dto.id) + "/fields")(dto);
        },
        whenCompanyEmailDomainsCheck: createFakePostResponder(fakeHttp, base + "/emailDomains/check"),
    };
    return __assign(__assign({}, api), handler);
};
//# sourceMappingURL=testkit.js.map